import { FETCH_PRODUCT_SHQ_SHIPPING_ORIGINS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PRODUCT_SHQ_SHIPPING_ORIGINS:
      return action.payload
    default:
      return state
  }
}
